import { useContext, useEffect, useState } from "react";
import './googleLogin.css'
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";
import { googleLoginServices } from "services/googleLoginServices";
import AuthContext from "contexte/AuthContext";


const GoogleLoginComposant = () => {
    const { login } = useContext(AuthContext);

    const handleSuccess = async (credentialResponse) => {
        try {
            const googleToken = credentialResponse.credential;
            const googleTokenDecoded = jwt_decode(googleToken);
            const { data } = await googleLoginServices(googleTokenDecoded)

            const jwt = jwt_decode(data.accessToken);

            const redirect = jwt.role === 4 ? '/users/call/list ' : '/';

            login(data.accessToken, jwt.email, redirect);
        } catch (err) {
            console.error("Login error:", err);
        }
    }

    return (
        <div className="content">
            <img src="/img/logoWhite.svg" alt="logo Goliaths blanc" />
            <p className="headline">Connectez-vous pour accéder à l'admin de Goliaths</p>
            <GoogleLogin
                onSuccess={handleSuccess}
                onError={() => {
                    console.log('Login Failed');
                }}
            />
        </div>
    )
}

export default GoogleLoginComposant